import { COOKIE_DOMAIN, COOKIE_SECURE } from '../config.js';

// Il ne reste ici que la plomberie de la PURGE du cookie legacy `authToken`
// (App.jsx) : la suppression doit porter les mêmes attributs — notamment
// domain=.globe-groupe.com — que le cookie posé par les apps non migrées, sinon
// le navigateur ne le supprime pas. À retirer avec la purge, quand Weekly aura
// rejoint Connect.
const setCookie = (name, value, options = {}) => {
  const cookieOptions = {
    domain: COOKIE_DOMAIN,
    path: '/',
    secure: COOKIE_SECURE,
    sameSite: 'strict',
    ...options
  };

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  for (const [key, val] of Object.entries(cookieOptions)) {
    if (val === true) {
      cookieString += `; ${key}`;
    } else if (val !== false && val !== null && val !== undefined) {
      cookieString += `; ${key}=${val}`;
    }
  }

  document.cookie = cookieString;
};

export const removeCookie = (name) => {
  // Le cookie legacy a pu être posé sur le domaine configuré (prod) ou sur le
  // registrable du host courant (dev, previews) : on expire les deux, plus la
  // variante host-only — un attribut domain qui ne correspond pas, c'est une
  // suppression qui no-op en silence.
  const registrable = '.' + window.location.hostname.split('.').slice(-2).join('.');
  for (const domain of new Set([COOKIE_DOMAIN, registrable, null])) {
    setCookie(name, '', { 'max-age': -1, domain });
  }
};
